export default "__VITE_ASSET__Bg8oEs8y__"